<template>
  <div>
    <b-modal

      id="details-modal"
      ref="details-modal"
      :title="'Alacak Geçmişi'"
      ok-only
      hide-footer
      size="xl"
    >
      <b-row>
        <b-col md="12">
          <customer-old-debts
            :useruyumcode="useruyumcode"
            :customer-name="selectedCustomerName"
          />
        </b-col>

      </b-row>
    </b-modal>
    <b-card no-body>
      <b-card-header>
        <!-- title and subtitle -->
        <div>
          <b-card-title class="mb-1">
            Müşteri Alacak Listesi
          </b-card-title>
          <b-card-sub-title />
        </div>
        <!--/ title and subtitle -->

        <!-- badge -->
        <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
          <h5 class="font-weight-bolder mb-0 mr-1" />

        </div>
      <!--/ badge -->
      </b-card-header>

      <b-card-body>
        <!-- search input -->
        <div class="custom-search d-flex justify-content-end">
          <b-form-group>
            <div class="d-flex align-items-center">
              <label class="mr-1">Firma Adı Arayın</label>
              <b-form-input
                v-model="searchTerm"
                placeholder="Firma Adı Giriniz"
                type="text"
                class="d-inline-block"
                @input="handleSearch"
              />
            </div>
          </b-form-group>
        </div>

        <!-- table -->
        <vue-good-table
          mode="remote"
          :columns="columns"
          small
          :rows="rows"
          :is-loading.sync="isLoading"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
          @on-sort-change="onSortChange"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field == 'created_at'">
              <span style="font-size:0.8em;">{{ $format_datetime(props.row.created_at) }}</span>
            </span>
            <span v-else-if="props.column.field == 'actions'">
              <b-button

                v-if="!customerName"
                size="sm"
                variant="outline-primary"
                @click="showDetails(props.row.customer_name)"
              >
                Detaylar
              </b-button>
            </span>
            <span v-else-if="props.column.field == 'total_debt'">
              <span style="font-size:0.8em;">{{ $staticParams.formatCurrency(props.row.total_debt) }}</span>
            </span>
            <span v-else-if="props.column.field == 'total_due'">
              <span style="font-size:0.8em;">{{ $staticParams.formatCurrency(props.row.total_due) }}</span>
            </span>
            <span v-else-if="props.column.field == 'balance_due'">
              <span style="font-size:0.8em;">{{ $staticParams.formatCurrency(props.row.balance_due) }}</span>
            </span>
            <span
              v-else
              style="font-size:0.8em;"
            >
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap ">
                  Showing 1 to
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="pages"

                  class="mx-1"
                  @input="handlePageChange"
                />
                <span class="text-nowrap"> of {{ totalRows }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="totalRows"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handleChangePage"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BPagination, BFormGroup, BFormInput, BFormSelect, BModal, BButton, BRow, BCol,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store'
import CustomerOldDebts from './CustomerOldDebts.vue'

export default {
  components: {
    BCardHeader,
    BPagination,
    BFormGroup,
    BFormInput,
    BModal,
    BButton,
    BRow,
    BCol,
    BFormSelect,
    VueGoodTable,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    CustomerOldDebts,
  },
  props: {
    useruyumcode: {
      type: String,
      default: '',
    },
    customerName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedCustomerName: null,
      pageLength: 50,
      dir: false,
      isLoading: false,
      sort: 'desc',
      totalRows: 0,
      order_column: 'balance_due',
      pages: ['10', '30', '50'],
      page: 1,
      columns: [
        {
          label: 'Müşteri Adı',
          field: 'customer_name',
        },
        {
          label: 'Toplam Borç',
          field: 'total_debt',
        },
        {
          label: 'Toplam Alacak',
          field: 'total_due',
        },
        {
          label: 'Bakiye Alacak',
          field: 'balance_due',
        },
        {
          label: 'Veri Güncellenme Zamanı',
          field: 'created_at',
        },
        {
          label: '',
          field: 'actions',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {

  },
  watch: {
    useruyumcode() {
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    showDetails(customerName) {
      this.selectedCustomerName = customerName
      this.$refs['details-modal'].show()
    },
    fetchData() {
      store
        .dispatch('app-reports/fetchCustomerDebts', {
          representative_uyum_code: this.useruyumcode,
          start_date: this.startdate,
          end_date: this.enddate,
          ordering: this.sort,
          data_count: this.pageLength,
          search_term: this.searchTerm,
          order_column: this.order_column,
          page: this.page,
          customer_name: this.customerName,
        })
        .then(response => {
          const { data } = response.data.data
          const { meta } = response.data
          this.totalRows = meta.total
          this.rows = data
        })
        .catch(() => {
        })
    },
    // eslint-disable-next-line no-unused-vars
    handleSearch(searching) {
      this.fetchData()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchData()
    },
    // eslint-disable-next-line no-unused-vars
    handlePageChange(active) {
      this.fetchData()
    },
    onSortChange(params) {
      this.order_column = params[0].field
      this.sort = params[0].type
      this.fetchData()
    },
  },

}
</script>
